import { Sheet } from "@breakingthelines/design-system";

import styles from "./membership-expiry-sheet.module.css";

// A Sheet, not an AlertDialog, because it closes on backdrop click and
// Escape — which the AlertDialog cannot do for this kind of dialog (Base UI's
// AlertDialogRoot hardcodes `disablePointerDismissal: true` and doesn't
// expose a prop to turn it off). An end-date edit is never a destructive
// confirmation, so dismissing it by clicking away must not be blocked. Used
// by both user-detail.tsx (the single-membership card) and scholarships.tsx
// (the manage list's per-row action).
export interface MembershipExpirySheetProps {
  open: boolean;
  onClose: () => void;
  title: string;
  description: string;
  dateValue: string;
  onDateChange: (value: string) => void;
  onSave: () => void;
  saving: boolean;
  saveLabel: string;
  /** Omit to hide the "Make permanent" affordance entirely. */
  onMakePermanent?: () => void;
}

export function MembershipExpirySheet({
  open,
  onClose,
  title,
  description,
  dateValue,
  onDateChange,
  onSave,
  saving,
  saveLabel,
  onMakePermanent,
}: MembershipExpirySheetProps) {
  return (
    <Sheet open={open} onClose={onClose} title={title} widthClass="w-full sm:w-[400px]">
      <div className={styles.form}>
        <p className={styles.subtitle}>{description}</p>

        <label className={styles.field}>
          <span className={styles.fieldLabel}>End date</span>
          <input
            type="date"
            className={styles.dateInput}
            value={dateValue}
            min={new Date().toISOString().slice(0, 10)}
            onChange={(event) => onDateChange(event.currentTarget.value)}
          />
        </label>

        <div className={styles.actions}>
          <button type="button" className={styles.cancelButton} onClick={onClose} disabled={saving}>
            Cancel
          </button>
          {onMakePermanent ? (
            <button
              type="button"
              className={styles.makePermanentButton}
              onClick={onMakePermanent}
              disabled={saving}
            >
              Make permanent
            </button>
          ) : null}
          <button
            type="button"
            className={styles.saveButton}
            disabled={saving || !dateValue}
            onClick={onSave}
          >
            {saving ? "Saving…" : saveLabel}
          </button>
        </div>
      </div>
    </Sheet>
  );
}
